import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { getAction } from '@/api/manage';
moment.locale('zh-cn');
export default {
  data: function data() {
    return {
      time: '',
      loading: true,
      tableLoading: true,
      columns: [{
        title: '参数',
        width: '30%',
        dataIndex: 'param',
        scopedSlots: {
          customRender: 'param'
        }
      }, {
        title: '描述',
        width: '40%',
        dataIndex: 'text',
        scopedSlots: {
          customRender: 'text'
        }
      }, {
        title: '当前值',
        width: '30%',
        dataIndex: 'value',
        scopedSlots: {
          customRender: 'value'
        }
      }],
      dataSource: [],
      dataSourceDisk: [],
      // 列表通过 textInfo 渲染出颜色、描述和单位
      textInfo: {
        'system.cpu.count': {
          color: 'green',
          text: 'CPU 数量',
          unit: '核'
        },
        'system.cpu.usage': {
          color: 'green',
          text: '系统 CPU 使用率',
          unit: '%'
        },
        'process.start.time': {
          color: 'purple',
          text: '应用启动时间点',
          unit: ''
        },
        'process.uptime': {
          color: 'purple',
          text: '应用已运行时间',
          unit: '秒'
        },
        'process.cpu.usage': {
          color: 'purple',
          text: '当前应用 CPU 使用率',
          unit: '%'
        }
      },
      // 当一条记录中需要取出多条数据的时候需要配置该字段
      moreInfo: {},
      columnsDisk: [{
        title: '磁盘名称',
        width: '30%',
        dataIndex: 'name',
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        title: '磁盘大小',
        width: '20%',
        dataIndex: 'max',
        scopedSlots: {
          customRender: 'max'
        }
      }, {
        title: '已使用大小',
        width: '20%',
        dataIndex: 'rest',
        scopedSlots: {
          customRender: 'rest'
        }
      }, {
        title: '使用率',
        width: '30%',
        dataIndex: 'restPPT',
        scopedSlots: {
          customRender: 'restPPT'
        }
      }]
    };
  },
  created: function created() {
    this.loadTomcatInfo();
  },
  methods: {
    handleClickUpdate: function handleClickUpdate() {
      this.loadTomcatInfo();
    },
    loadTomcatInfo: function loadTomcatInfo() {
      var _this = this;

      this.tableLoading = true;
      this.time = moment().format('YYYY年MM月DD日 HH时mm分ss秒');
      Promise.all([getAction('actuator/metrics/system.cpu.count'), getAction('actuator/metrics/system.cpu.usage'), getAction('actuator/metrics/process.start.time'), getAction('actuator/metrics/process.uptime'), getAction('actuator/metrics/process.cpu.usage'), getAction('actuator/redis/queryDiskInfo')]).then(function (res) {
        var info = [];

        for (var i = 0; i < 5; i++) {
          var more = _this.moreInfo[res[i].name];

          if (!(more instanceof Array)) {
            more = [''];
          }

          more.forEach(function (item, idx) {
            var param = res[i].name + item;
            var val = res[i].measurements[idx].value;

            if (param === 'system.cpu.usage' || param === 'process.cpu.usage') {
              val = _this.convert(val, Number);
            }

            if (param === 'process.start.time') {
              val = _this.convert(val, Date);
            }

            info.push({
              id: param + i,
              param: param,
              text: 'false value',
              value: val
            });
          });
        }

        _this.dataSource = info;

        if (res[5].success) {
          for (var i = 0; i < res[5].result.length; i++) {
            res[5].result[i].restPPT = res[5].result[i].restPPT / 10;
          }

          _this.dataSourceDisk = res[5].result;
        }
      }).catch(function (e) {
        console.error(e);

        _this.$message_custom('获取服务器信息失败', 'error');
      }).finally(function () {
        _this.loading = false;
        _this.tableLoading = false;
      });
    },
    convert: function convert(value, type) {
      if (type === Number) {
        return Number(value * 100).toFixed(2);
      } else if (type === Date) {
        return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');
      }

      return value;
    }
  }
};